import { LE } from "@/constants/enums";
import type { DeliverableAcceptanceForm } from "@/views/project/project";
import { assignFilesAndDocsByDocType, FileDocPropertyName } from "@modernary/mui/components/document";
import { traverseAndMutateObject } from "@modernary/mui/utils/helpers";

export default {
  requestAdapter,
  responseAdapter,
};
export const dafDocTypeToFieldMap = new Map<LE.DocumentType, FileDocPropertyName>([
  [LE.DocumentType.DeliverableAcceptance, new FileDocPropertyName("deliverableAcceptance")],
]);

async function responseAdapter(response: { data: DeliverableAcceptanceForm }) {
  assignFilesAndDocsByDocType(dafDocTypeToFieldMap, response.data);

  return response.data;
}
function requestAdapter(data: DeliverableAcceptanceForm) {
  return data;
}
